import _ from 'lodash';
import qs from 'qs';
import { createRouter, createWebHashHistory } from 'vue-router';
import SharePage from './SharePage.vue';

export const shareRouter = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            // 适配社交媒体分享，重定向到分享详情页。用于处理facebook、linkedin平台插入参数/截断vue路由的问题
            path: '/',
            component: {
                render() {
                    return null;
                },
            },
            beforeEnter: (to, from, next) => {
                const params = qs.parse(location.search.replace('?', ''));
                const shareId = params.id;
                const targetPath = `/share/#/${shareId}?${qs.stringify(_.omit(params, ['id']))}`;
                console.log('Redirect to share detail', targetPath);
                location.href = targetPath;
                next(false);
            },
        },
        {
            name: 'ShareDetail',
            path: '/:share_id',
            component: SharePage,
        }
    ],
})

export default shareRouter;
